<div class="container logout">
  <div class="bg-custom">
    <div class="container manage-benefits">
      <div>
        <div class="mt-3">
          <div class="container col-xs-12 .col-12 row g-3">
            <div class="col-md-12 col-sm-12">
              <div class="py-4">
                 <h1 class="visually-hidden">Session Error</h1>
                <p>{{(isMobileAFB ? 'INVALIDSESSION_STATIC2' : (mobileAppRidpUser ? 'INVALIDSESSION_STATIC1_MOBILE' : 'INVALIDSESSION_STATIC1')) | globalTranslate}}</p>
              </div>
            </div>
         </div>
        </div>
      </div>
    </div>
  </div>
</div>
